import React, { useState } from 'react';
import { Avatar, Box, Button, Divider, Flex, IconButton, Input } from '@chakra-ui/react';
import { EditOutlined } from '@mui/icons-material';
import apiClient from '../clients/apiClient.js';

function ProfileInfo({ name, role, department, photo, refreshData, lastName }) {
  const [isEditing, setIsEditing] = useState(false);
  const [profile, setProfile] = useState({
    name,
    lastName,
    role,
    department,
    photo,
  });
  const [photoFile, setPhotoFile] = useState(null);

  React.useEffect(() => {
    console.log('ProfileInfo: Setting profile:', { name, lastName, role, department, photo });
    setProfile({ name, lastName, role, department, photo });
  }, [name, lastName, role, department, photo]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    let personal_info = {
      name: profile.name,
      last_name: profile.lastName,
      department: profile.department,
    }
    if (photoFile) {
      const fileData = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(photoFile);
      });
      const fileNewData = fileData?.split(',')[1];

      personal_info.profile_photo = fileNewData;
      const fileExtension = photoFile.name.split('.').pop();
      personal_info.profile_photo_ext = fileExtension;
    }

    apiClient.post('/manage-account', {
        personal_info
    }).then(({ data }) => {
      setIsEditing(false); // Exit edit mode after saving
      refreshData(); // Refresh data from server
    })
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
  };

  const handleLastNameChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, lastName: value });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfile({ ...profile, photo: reader.result });
      };
      reader.readAsDataURL(file);
      setPhotoFile(file);
    }
  };

  return (
    <div>
      <Flex justifyContent={'space-between'}>
        <Box fontSize={'24px'} fontWeight={600}>
          Personal info
        </Box>
        {isEditing ? (
          <Flex gap={2}>
            <Button
              onClick={() => setIsEditing(false)}
              size="sm"
              variant="ghost"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              bg={'#2584FD'}
              color={'white'}
              size="sm"
              marginRight={"8px"}
              _hover={{ bg: '#2584FD' }}
            >
              Save
            </Button>
          </Flex>
        ) : (
          <Button onClick={handleEditClick} size="sm" marginRight={"8px"}>
            Edit
          </Button>
        )}
      </Flex>
      <Box py={4}>
        <Divider />
      </Box>
      <Flex flexDir={'column'} gap={8}>
        <Flex alignItems={'center'}>
          <Box width={'180px'} fontWeight={'500'}>
            First Name
          </Box>
          {isEditing ? (
            <Input
              type="text"
              name="name"
              value={profile.name}
              onChange={handleChange}
              maxWidth={'240px'}
            />
          ) : (
            name
          )}
        </Flex>
        <Flex alignItems={'center'}>
          <Box fontWeight={'500'} width={'180px'}>
            Last Name
          </Box>
          {isEditing ? (
            <Input
              type="text"
              name="last name"
              value={profile.lastName}
              onChange={handleLastNameChange}
              maxWidth={'240px'}
            />
          ) : (
            lastName
          )}
        </Flex>
        <Flex alignItems={'center'}>
          <Box fontWeight={'500'} width={'180px'}>
            Role
          </Box>
          {isEditing ? (
            <Input
              type="text"
              name="role"
              value={profile.role}
              onChange={handleChange}
              maxWidth={'240px'}
              disabled
            />
          ) : (
            role
          )}
        </Flex>
        <Flex alignItems={'center'}>
          <Box fontWeight={'500'} width={'180px'}>
            Department
          </Box>
          {isEditing ? (
            <Input
              type="text"
              name="department"
              value={profile.department}
              onChange={handleChange}
              maxWidth={'240px'}
            />
          ) : (
            department
          )}
        </Flex>
        <Flex>
          <Box width={'180px'} fontWeight={'500'} alignContent={"center"}>
            Profile Photo
          </Box>
          {isEditing ? (
            <Box position="relative">
              <Avatar
                name={profile.name + " " + profile.lastName}
                src={profile.photo}
                style={{ marginLeft: '8px', cursor: 'pointer', filter: 'blur(1px)' }}
                onClick={() => document.getElementById('fileInput').click()}
              />
              <Box
                position="absolute"
                bottom="0"
                right="0"
                bg="transparent"
                borderRadius="full"
                p={1}
                cursor="pointer"
                onClick={() => document.getElementById('fileInput').click()}
              >
                <IconButton
                  sx={{ 
                    padding: 0,
                    fontSize: 16,
                    backgroundColor: 'transparent',
                    color: '#5d5d5d',
                    '&:hover': { backgroundColor: 'transparent' } 
                  }}
                >
                  <EditOutlined
                    sx={{ 
                      padding: 0, 
                      fontSize: 24, 
                      color: '#5d5d5d'
                    }}
                  />
                </IconButton>
              </Box>
              <Input
                id="fileInput"
                type="file"
                accept="image/*"
                onChange={handlePhotoChange}
                style={{ display: 'none' }}
              />
            </Box>
          ) : (
            <Avatar
              name={name+" "+ lastName}
              src={photo}
              style={{ marginLeft: '8px' }}
            />
          )}
        </Flex>
      </Flex>
    </div>
  );
}

export default ProfileInfo;
